import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Arrival = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M22,20 L22,22 L3,22 L3,20 L22,20 Z M10.62,3 L12.55,3.51 L15.31,12.53 L20.62,13.95 C21.42,14.17 21.89,14.99 21.68,15.79 C21.46,16.59 20.64,17.06 19.84,16.85 L19.84,16.85 L3.27,12.41 L3.27,7.24 L4.72,7.63 L5.65,9.95 L10.62,11.28 L10.62,3 Z", id: "Combined-Shape", fill: "#008CBA" })));
};
export default Arrival;
